import { KeyboardEvent } from 'react';

export function blurOnEnterKey(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
        event.currentTarget.blur();
    }
}
